// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import _ from 'lodash';
import BaseStore from './base-store';

/**
 * @deprecated use react-redux
 */
class BaseComponent<PropsType, StateType> extends React.Component<PropsType, StateType> {
    protected hasMounted: boolean;
    protected stores: { [storeId: string]: IFlux2Store | IBaseStore<any> };

    constructor(props: PropsType, options: {}) {
        super(props, options);
        this.onStoreChange = this.onStoreChange.bind(this);
    }

    public componentDidMount(): void {
        this.hasMounted = true;
        _.forOwn(this.stores, (store: IFlux2Store) => {
            store.on('change', this.onStoreChange);
        });
    }

    public componentWillUnmount(): void {
        this.hasMounted = false;
        _.forOwn(this.stores, (store: IFlux2Store) => {
            store.off('change', this.onStoreChange);
        });
    }

    protected getStateFromStore(): StateType {
        const result = {};
        _.forOwn(this.stores, (store: IFlux2Store | IBaseStore<any>, storeId: string) => {
            result[storeId] = BaseComponent.getStateFromStore(store);
        });
        return result as StateType;
    }

    protected initialize(): void {
        this.state = this.getStateFromStore();
    }

    protected onStoreChange(): void {
        if (this.hasMounted) {
            const newState: StateType = this.getStateFromStore();
            this.setState(newState);
        }
    }

    public subscribeToStore(storeId: string, store: IFlux2Store): void {
        this.stores[storeId] = store;
        if (this.hasMounted) {
            store.on('change', this.onStoreChange);
        }
    }

    public unSubscribeFromStore(storeId: string): void {
        const store = this.stores[storeId];
        if (store) {
            store.off('change', this.onStoreChange);
        }
    }

    // using to partial state update
    public updateState(newState: any): void {
        this.setState(newState);
    }

    private static getStateFromStore(store: IFlux2Store | IBaseStore<any>): any {
        return this.isFluxe(store)
            ? this.getFluxeState(store as IFlux2Store)
            : this.getBaseStore(store as IBaseStore<any>);
    }

    private static getFluxeState(store: IFlux2Store): any {
        return store.state || {};
    }

    private static getBaseStore(store: IBaseStore<any>): any {
        return store.getState();
    }

    private static isFluxe(store: IFlux2Store | IBaseStore<any>): boolean {
        return !(store instanceof BaseStore);
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default BaseComponent;
